import { useTranslation, useNextgenRouter, useBreakpoint, Breakpoints } from '@nextgen-web-framework/all';
import { VerticalTabNavigation, MenuDropdown, NavigationSource } from '@commerce-webcomponents/ui';
import Layout from '../Layout/Layout';
import { AboutAmwayLayoutProps } from './types/propsTypes';
import styles from './AboutAmwayLayout.module.scss';
import { CMSTransformerDataType } from 'types/common';

const AboutAmwayLayout = (props: AboutAmwayLayoutProps) => {
  const router = useNextgenRouter();
  const translate = useTranslation();
  const viewPortType = useBreakpoint() as Breakpoints;
  const isDesktop = viewPortType === Breakpoints.LG || viewPortType === Breakpoints.XL;
  const goToRoute = (url: string) => {
    if (url !== activeRoute) {
      router.push(url);
    }
  };

  const transformNavigationLinks = (items: CMSTransformerDataType) =>
    items.map((item: CMSTransformerDataType) => ({
      label: item.text,
      url: item.url,
      target: item?.target,
    }));

  const activeRoute = router.pathname?.replace(`/${router.params?.locale}`, '');

  return (
    <Layout
      hasTopMobileHeader={true}
      headerProps={{
        headerElement: <div className={styles['about-amway-title']}>{translate('amshop.aboutAmway')}</div>,
        isStaticHeader: true,
      }}
      header={props.header}
      footer={props.footer}
    >
      <div className={styles['about-amway-container']} data-testid="about-amway-container-test-id">
        {props.data?.links &&
          (isDesktop ? (
            <VerticalTabNavigation
              source={NavigationSource.CONTENT}
              data={transformNavigationLinks(props.data?.links)}
              activeRoute={activeRoute}
              goToRoute={goToRoute}
              content={<>{props.children}</>}
              customClass={styles['left-tab-sticky']}
            />
          ) : (
            <MenuDropdown
              menuData={transformNavigationLinks(props.data?.links)}
              activeRoute={activeRoute as string}
              content={<>{props.children}</>}
            />
          ))}
      </div>
    </Layout>
  );
};

export default AboutAmwayLayout;
